/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { integer, sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const bookingOnlinePatientFieldSettings = sqliteTable(
  'booking_online_patient_field_settings',
  {
    id: text('id').primaryKey().notNull(),
    org_id: text('org_id'),
    clinic_id: text('clinic_id'),
    field_key: text('field_key'),
    enabled: integer('enabled'),
    required: integer('required'),
    locked: integer('locked'),
    section: text('section'),
    created_at: text('created_at'),
    updated_at: text('updated_at'),
  },
);
